import { useTkv2HandleIconClick } from '@aloft/toolkit-frontend/src/components/ReferenceBar/useTkv2HandleIconClick.ts';

import { selectReferenceBarUI } from '../../redux/features/selectors/referenceBarUISelectors.ts';
import { useAppSelector } from '../../redux/hooks.ts';
import { Tkv2ReferenceBarItem } from './Tkv2ReferenceBarItem.tsx';

export const Tkv2MapItem = () => {
  const { referenceViewOpen, selectedDataSheet } = useAppSelector(selectReferenceBarUI);
  const handleIconClick = useTkv2HandleIconClick();

  const isSelected = selectedDataSheet === 'mls-map' && referenceViewOpen;

  return (
    <Tkv2ReferenceBarItem
      id="property_map"
      label="Property Map"
      icon="map-2"
      isSelected={isSelected}
      onClick={() => handleIconClick('mls-map')}
    />
  );
};
